/**
 * Bill Vote Summary Component
 * Extracted from BillDetailPage.tsx for better maintainability
 * Displays vote count summary with visual breakdown
 */

import React from 'react';
import StatCard, { StatCardRow } from '../StatCard';
import { calculateVotePercentages } from '../../utils/voteUtils';

interface BillVoteSummaryProps {
  aye: number;
  no: number;
  excused: number;
  absent: number;
  showPercentages?: boolean;
  className?: string;
}

/**
 * BillVoteSummary displays a visual breakdown of vote counts
 * 
 * @example
 * ```tsx
 * <BillVoteSummary
 *   aye={45}
 *   no={20}
 *   excused={2}
 *   absent={1}
 *   showPercentages={true}
 * />
 * ```
 */
const BillVoteSummary: React.FC<BillVoteSummaryProps> = ({
  aye,
  no,
  excused,
  absent,
  showPercentages = true,
  className = ''
}) => {
  const { ayePercent, noPercent } = calculateVotePercentages(aye, no, excused, absent);

  return (
    <StatCardRow className={className}>
      <StatCard
        value={aye}
        label={showPercentages ? `Yes (${ayePercent}%)` : 'Yes'}
        variant="success"
      />
      <StatCard
        value={no}
        label={showPercentages ? `No (${noPercent}%)` : 'No'}
        variant="danger"
      />
      <StatCard value={excused} label="Excused" variant="warning" />
      <StatCard value={absent} label="Absent" />
    </StatCardRow>
  );
};

export default BillVoteSummary;

